export const boardWorkloadTour = {
  key: "boardWorkload",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-workload-chart"]',
      content: t("Tour_BoardWorkload_Chart"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-workload-drilldown"]',
      content: t("Tour_BoardWorkload_Drilldown"),
      placement: "right",
    },
    {
      target: '[data-tour="board-workload-filter"]',
      content: t("Tour_BoardWorkload_Filter"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-workload-reassign"]',
      content: t("Tour_BoardWorkload_Reassign"),
      placement: "bottom",
    },
  ],
};
